// Status do processamento de pedidos de compra (campo `info-status-pedido`)
// 0 Iniciado | 1 Processando | 2 Concluído | 3 Erro | 4 Aguardando Aprovação | 5 Recusado

export interface IProcessStatusChecks {
  iniciadoCheck: boolean
  atencaoCheck: boolean
  noprazoCheck: boolean
  atrasadoCheck: boolean
  aguardandoAprovacaoCheck: boolean
  recusadoCheck: boolean
}

// Status do grupo (protocolo) calculado com TODAS as linhas do grupo:
// erro tem prioridade, depois recusado, aguardando aprovação e processando
export const getProcessGroupStatus = (rows: any[]) => {
  let hasError = false
  let hasProcessing = false
  let hasAguardandoAprovacao = false
  let hasRecusado = false
  let allConcluded = true
  let allStarted = true
  let errorCount = 0

  for (const item of rows) {
    const status = String(item['info-status-pedido'])

    if (status === '3') {
      hasError = true
      errorCount++
    }
    if (status === '1') hasProcessing = true
    if (status === '4') hasAguardandoAprovacao = true
    if (status === '5') hasRecusado = true
    if (status !== '2') allConcluded = false
    if (status !== '0') allStarted = false
  }

  let statusFinal = '0'
  if (hasError) statusFinal = '3'
  else if (hasRecusado) statusFinal = '5'
  else if (hasAguardandoAprovacao) statusFinal = '4'
  else if (hasProcessing) statusFinal = '1'
  else if (allConcluded) statusFinal = '2'
  else if (allStarted) statusFinal = '0'

  return { statusFinal, errorCount }
}

export const isProcessStatusVisible = (
  statusFinal: string,
  checks: IProcessStatusChecks
) => {
  switch (statusFinal) {
    case '0':
      return !!checks.iniciadoCheck
    case '1':
      return !!checks.atencaoCheck
    case '2':
      return !!checks.noprazoCheck
    case '3':
      return !!checks.atrasadoCheck
    case '4':
      return !!checks.aguardandoAprovacaoCheck
    case '5':
      return !!checks.recusadoCheck
    default:
      return false
  }
}

// Linhas cujos grupos (`info-id`) estão visíveis pelos checkboxes de status
export const filterVisibleProcessRows = (
  rows: any[],
  checks: IProcessStatusChecks
) => {
  const groups = new Map<any, any[]>()
  for (const row of rows) {
    const key = row['info-id']
    if (!groups.has(key)) groups.set(key, [])
    groups.get(key)!.push(row)
  }

  const visibleGroups = new Set<any>()
  groups.forEach((groupRows, key) => {
    const { statusFinal } = getProcessGroupStatus(groupRows)
    if (isProcessStatusVisible(statusFinal, checks)) visibleGroups.add(key)
  })

  return rows.filter(row => visibleGroups.has(row['info-id']))
}
